import * as Yup from 'yup';

import { flightTopSchema } from 'modules/shared/FlightTop';
import regDocValidationSchema from 'modules/shared/RegOfDocuments/schema';
import { getValidationSchema, transportSchema } from 'modules/shared/FlightDetails';
import { getValidationSchema as getDepartureCarValidationSchema } from 'modules/shared/DepartureData';
import { departureCommentSchema } from 'modules/shared/DepartureComment';
import { unloadingSchema } from 'modules/shared/UnloadingData';
import { RolesMode } from '../../../../entities/Roles';
import { tripStatuses, TripStatusIds } from '../../../../entities/Trip';

export const useValidationSchema = (
  mode: RolesMode,
  statusId: TripStatusIds | number,
  isLoading: boolean,
  operatingProcedure: string,
  useVisitorDoc: boolean = true,
  useTransportDoc: boolean = true,
) => {
  const isOrdering = mode === 'ordering';
  const isSecurity = mode === 'security';
  const isDirector = mode === 'director';

  return Yup.object().shape({
    ...(isSecurity && statusId === tripStatuses.create ? flightTopSchema.fields : {}),
    ...(isSecurity && [tripStatuses.create].includes(statusId)
      ? getValidationSchema(statusId, isLoading, useVisitorDoc).fields
      : {}),
    ...(isSecurity && [tripStatuses.parkingInLine, tripStatuses.unloading].includes(statusId)
      ? getValidationSchema(statusId, true, useVisitorDoc).fields
      : {}),
    ...(isSecurity && [tripStatuses.create].includes(statusId)
      ? transportSchema(statusId, operatingProcedure, useTransportDoc).fields
      : {}),
    ...(isSecurity && [tripStatuses.parkingInLine, tripStatuses.unloading].includes(statusId)
      ? transportSchema(statusId, operatingProcedure, useTransportDoc).fields
      : {}),
    ...(isSecurity && statusId !== tripStatuses.create && isLoading
      ? getDepartureCarValidationSchema(mode, statusId, operatingProcedure).fields
      : {}),
    ...(isSecurity && statusId !== tripStatuses.create && !isLoading ? unloadingSchema.fields : {}),

    ...(statusId === tripStatuses.parkingInLine ? regDocValidationSchema(statusId, operatingProcedure).fields : {}),
    ...departureCommentSchema().fields,

    ...(isOrdering && isLoading ? regDocValidationSchema(statusId, operatingProcedure).fields : {}),
    ...(isOrdering ? getValidationSchema(statusId, isLoading, useVisitorDoc).fields : {}),
    ...(isOrdering ? transportSchema(statusId, operatingProcedure, useTransportDoc).fields : {}),
    ...(isOrdering && statusId !== tripStatuses.create && statusId !== tripStatuses.parkingInLine && isLoading
      ? getDepartureCarValidationSchema(mode, statusId, operatingProcedure).fields
      : {}),

    ...(isDirector ? regDocValidationSchema(statusId, operatingProcedure).fields : {}),
    ...(isDirector ? getValidationSchema(statusId, isLoading, useVisitorDoc).fields : {}),
    ...(isDirector ? transportSchema(statusId, operatingProcedure, useTransportDoc).fields : {}),
    ...(isDirector ? getDepartureCarValidationSchema(mode, statusId, operatingProcedure).fields : {}),
  });
};
